// shared-lib/cabinet-runs/doubleBowlUnit.js
//
// TWO BOWLS UNDER A CABINET LINE: one double-bowl unit, or two single sink
// bases?
//
// The user's call, 2026-10-21 — "(a) is fine for now, but we may want to
// change this later". (a) is the line's double-bowl unit (Venus's
// VSD60DOUBLE) wherever both bowls fit inside it, and one single sink base
// per bowl everywhere else — and since 2026-11-03 only where the unit leaves
// no more filler than the singles would ("two singles seem better than using
// fillers": a 72" double is 36 + 36, not 6 + 60 + 6; a tie keeps the unit).
// Set this to false and every two-bowl vanity in a line is built as two
// single sink bases; nothing else changes.
//
// It lives in a file of its own so that it is the WHOLE decision, in one
// place: `vanitySinkBay.js` reads it and nothing else decides it.

module.exports = { DOUBLE_BOWL_UNIT_WHEN_BOTH_FIT: true };
